import { Injectable } from '@angular/core';

import { VehicleInsurance } from '@models';
import { CrudService } from '../crud/crud.service';
import { HttpService } from '../http/http.service';

@Injectable({
  providedIn: 'root',
})
export class VehicleInsuranceService extends CrudService<VehicleInsurance> {
  constructor(http: HttpService) {
    super('vehicle-insurance', http);
  }

  async getByVehicleId(vehicleId: string): Promise<VehicleInsurance> {
    const endpoint = `${this.url}/vehicle/${vehicleId}`;
    const response = await this.http.get<VehicleInsurance>(endpoint);
    if (!response.success) throw new Error(response.message);
    return response.data;
  }

  // override methods which are not available for this service
  override create(data: Partial<VehicleInsurance>): Promise<VehicleInsurance> {
    throw new Error('Method not available.');
  }
  override update(data: Partial<VehicleInsurance>): Promise<VehicleInsurance> {
    throw new Error('Method not available.');
  }
  override delete(id: string): Promise<string> {
    throw new Error('Method not available.');
  }
}
